<template>
  <div>
    <v-icon
      :color="cameraColor"
      class="cursor-pointer me-3"
      @mouseenter="cameraColor = '#111f5e'"
      @mouseleave="cameraColor = '#c9c9c9'"
      @click="getImgClick"
    >
      {{ icon }}
    </v-icon>
    <v-file-input
      ref="uploader"
      style="width:0;height:0;position:absolute;clip:rect(0px,0px,0px,0px);"
      outlined
      hide-details
      single-line
      dense
      prepend-icon=""
      clearable
      accept="image/*"
      @change="getImg"
    />
    <v-dialog
      v-if="dialog"
      :value="true"
      persistent
      width="300"
    >
      <v-card
        dark
        color="white"
      >
        <v-progress-linear indeterminate />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImgSearch',
  data() {
    return {
      cameraColor: '#c9c9c9',
      dialog: false,
      icon: 'mdi-camera-plus-outline',
    };
  },
  created() {
  },
  methods: {
    ...mapActions(['getGoodsByImgAsync']),
    getImgClick() {
      this.$refs.uploader.$refs.input.click();
    },
    getImg(file) {
      this.icon = 'mdi-spin mdi-loading';
      if (!file) {
        return;
      }
      const postData = new FormData();
      postData.append('file', file);
      this.cameraColor = '#111f5e';
      this.getGoodsByImgAsync(postData)
        .then(() => {
          if (this.$route.name !== 'SearchImgGoodsList') {
            this.$router.push({ name: 'SearchImgGoodsList' });
          }
          this.$emit('update:img-searched', this.getObjectURL(file));
        })
        .finally(() => {
          this.dialog = false;
          this.cameraColor = '#c9c9c9';
          this.icon = 'mdi-camera-plus-outline';
        });
    },
    getObjectURL(file) {
      let url = null;
      // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
